export const dimensions = {
  maxWidth: 1280,
  setToMobileWidth: 820,
};
